import React from "react";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDispatch, useSelector } from "react-redux";
import { updateDates } from "../redux/activitiesSaga";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  let dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector((state) => state.activities.selectedRequestDates);
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.activities.currentUser
  );

  const update = (startDate, endDate) => {
    dispatch(updateDates({ startDate, endDate }));
  };
  return (
    <ReactDatePicker
      isRangePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      minDate={calendarStartDate}
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={update}
    />
  );
};

export default DatePicker;
